/* @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { InlineNotification, Link } from '@coursera/cds-core';

import { useDPMDialog } from 'bundles/degree-home/components/v3-dpm/context/DPMDialogContext';

import _t from 'i18n!nls/degree-home';

type Props = {
  onDismiss: () => void;
};

const styles = {
  notification: css`
    margin-bottom: var(--cds-spacing-200);
  `,
};

const PlanUpdatedNotification = ({ onDismiss }: Props) => {
  const { openDialog } = useDPMDialog();

  return (
    <InlineNotification
      css={styles.notification}
      severity="success"
      title={_t('Your plan was automatically updated')}
      onDismiss={onDismiss}
    >
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <Link component="button" onClick={() => openDialog('planUpdated')}>
        {_t('What changed?')}
      </Link>
    </InlineNotification>
  );
};

export default PlanUpdatedNotification;
